
export default {
  namespaced: true,
  state () {
    return {
      // history
      vnHistory: [
        {
          content: 'Trung tâm Huấn luyện bay trực thuộc Tổng công ty Hàng không Việt Nam được thành lập vào năm 1998 với chức năng tổ chức công tác huấn luyện phi công, tiếp viên và nhân viên điều hành khai thác bay của Hãng HKVN.' +
            '<br><br> Hiện nay Trung tâm Huấn luyện bay đã được Cục HKVN phê chuẩn là Cơ sở đào tạo huấn luyện nghiệp vụ nhân viên hàng không (ATO level 2), có chức năng thực hiện đa dạng các khóa huấn luyện dành cho phi công,' +
            'tiếp viên, nhân viên điều hành khai thác bay và cán bộ quản lý. <br><br> Bên cạnh sứ mệnh hoàn thành các kế hoạch huấn luyện đào tạo của Tổng công ty Hàng không Việt Nam, Trung tâm Huấn luyện bay đã và đang mở rộng việc cung cấp các khóa huấn luyện chất lượng cao,' +
            'phát triển dịch vụ cung ứng các trang thiết bị, cơ sở vật chất phục vụ công tác huấn luyện trong và ngoài lĩnh vực hàng không cho các đối tác trong và ngoài nước như Công ty Trực thăng Miền Bắc, Công ty Trực thăng Miền Nam, Jetstar Pacific Airlines, Cambodia Angkor Air,' +
            ' Sky Angkor Ailines,  Laos Airlines, Bassaka Air, Cebu Pacific Air, Skywing, v.v. <br><br> Với định hướng trở thành một tổ chức huấn luyện chuyên ngành hàng không chuyên nghiệp và có uy tín trong khu vực,' +
            ' Trung tâm Huấn luyện bay đã và đang cải tiến không ngừng nhằm nâng cao chất lượng công tác huấn luyện đào tạo, đáp ứng yêu cầu ngày càng đa dạng và khó khăn hơn tro'
        }
      ],
      enHistory: [
        {
          content: 'The Flight Training Center, a division of Vietnam Airlines, was established in 1998 with the responsibility of organizing training for pilots, flight attendants, and flight operations staff of Vietnam Airlines.' +
          ' <br><br> Currently, the Flight Training Center has been approved by the Vietnam Airlines Authority as an Aviation Training Organization (ATO level 2), with the function of conducting various training courses for pilots,' +
          'flight attendants, flight operations staff, and management personnel. <br><br> In addition to fulfilling the training and development plans of Vietnam Airlines, the Flight Training Center has been expanding its provision of' +
          'high-quality training courses and developing services to supply equipment and facilities for training activities within and outside the aviation sector to partners both domestically and internationally such as Northern Helicopter' +
          'Company, Southern Helicopter Company, Jetstar Pacific Airlines, Cambodia Angkor Air, Sky Angkor Airlines, Laos Airlines, Bassaka Air, Cebu Pacific Air, Skywing, etc. <br><br> With the goal of becoming a professional and reputable' +
          ' aviation specialized training organization in the region, the Flight Training Center is continuously improving to enhance the quality of training and meet increasingly diverse and challenging requirements in this field.'
        }
      ],
      // quality
      vnQuality: [
        {
          content: '<strong>Hệ thống quản lý chất lượng của Trung tâm</strong> được xây dựng phù hợp với các điều khoản của tiêu chuẩn TCVN ISO 9001:2015,' +
            'VAR và IOSA, nhằm đảm bảo việc tuân thủ các tiêu chuẩn trong công tác huấn luyện đào tạo nghiệp vụ nhân viên hàng không theo đúng yêu cầu của Luật định và hướng đến' +
            'thỏa mãn nhu cầu, sự mong đợi của khách hàng. <br><br> Trung tâm duy trì và liên tục phát triển Hệ thống quản lý chất lượng từ năm 2011 đến nay,' +
            'hệ thống được đánh giá chứng nhận và đánh giá giám sát định kỳ bởi tổ chức đánh giá BVC và AFNOR. <br><br> Chính sách chất lượng của Trung tâm là phục khách hàng với tiêu chí <strong>"<em>An Toàn - Chất lượng và Hiệu quả</em>"</strong>.',
          certificate1: 'quality1_vn.png',
          certificate2: 'quality2_vn.png'
        }
      ],
      enQuality: [
        {
          content: '<strong>The Quality Management System of the Training Center</strong> is designed in accordance with the provisions of TCVN ISO 9001:2015, VAR, and IOSA standards, to ensure compliance with standards in the training and development of aviation personnel as required by regulations and to meet the needs and expectations of customers. <br><br> The Training Center has maintained and continuously developed its Quality Management System since 2011. The system is regularly assessed and monitored by certification and evaluation organizations such as BVC and AFNOR. <br><br> The Quality Policy of the Training Center is to serve customers with the criteria of <strong>"Safety - Quality and Efficiency"</strong>.',
          certificate1: 'quality1_vn.png',
          certificate2: 'quality2_vn.png'
        }
      ],
      // location
      vnLocation: [
        {
          header: 'Địa chỉ:',
          location: '117 Hồng Hà, Phường 2, Tân Bình, Thành phố Hồ Chí Minh, Việt Nam'
        }
      ],
      enLocation: [
        {
          header: 'Address:',
          location: '117 Hong Ha, Ward 2, Tan Binh District, Ho Chi Minh City, Vietnam'
        }
      ],
      vnQaData: [
        {
          id: 1,
          question: 'Chúng tôi là công ty giao nhận và vận chuyển hàng không. Chúng tôi có thể ký hợp đồng vối Trung tâm về huấn luyện hàng hóa nguy hiểm được không?',
          answer: 'Câu trả lời cho câu hỏi 1',
          toggle: false
        },
        {
          id: 2,
          question: 'Công ty chúng tôi hoạt động trong ngành đường sắt. Chúng tôi muốn mời các giáo viên Trung tâm huấn luyện giảng dạy về giao tiếp và quan hệ khách hàng có được không? Chúng tôi phải liên lạc với bộ phận nào?',
          answer: 'Câu trả lời cho câu hỏi 2',
          toggle: false
        },
        {
          id: 3,
          question: 'Công ty tôi có nhu cầu huấn luyện cho Cán bộ - Công nhân viên, những người thường sử dụng máy bay để đi công tác về an toàn bay, xử lý các tình huống khẩn cấp, thoát hiểm - Trung tâm huấn luyện có tổ chức các khóa huấn luyện này không? Nếu có, thì thời gian học trong bao lâu? Học phí?',
          answer: 'Câu trả lời cho câu hỏi 3',
          toggle: false
        },
        {
          id: 4,
          question: 'Đăng ký dự thi phi công ở đâu? Các điều kiện dự tuyển?',
          answer: 'Câu trả lời cho câu hỏi 4',
          toggle: false
        },
        {
          id: 5,
          question: 'Xin cho biết sự khác biệt trong huấn luyện đào tạo tại Trung tâm huấn luyện bay và các trường đại học Hàng không khác trong nước (ví dụ như Học viện hàng không Việt nam)?',
          answer: 'Câu trả lời cho câu hỏi 5',
          toggle: false
        },
        {
          id: 6,
          question: 'Trung tâm huấn luyện bay đào tạo những ngành nghề nào?',
          answer: 'Câu trả lời cho câu hỏi 6',
          toggle: false
        }
      ],
      enQaData: [
        {
          id: 1,
          question: 'We are a freight and air transportation company. Can we sign a contract with the Training Center for training on dangerous goods?',
          answer: 'answer for the id 1 question',
          toggle: false
        },
        {
          id: 2,
          question: 'Our company operates in the railway industry. We want to invite instructors from the Training Center to teach communication and customer relations. Is this possible? Who should we contact?',
          answer: 'answer for the id 2 question',
          toggle: false
        },
        {
          id: 3,
          question: 'My company needs training for Officers - Employees who frequently use airplanes for business trips regarding flight safety, handling emergencies, and evacuation. Does the Training Center offer these training courses? If yes, how long is the course duration? What are the fees?',
          answer: 'answer for the id 3 question',
          toggle: false
        },
        {
          id: 4,
          question: 'Where can I register for pilot exams? What are the eligibility criteria?',
          answer: 'answer for the id 4 question',
          toggle: false
        },
        {
          id: 5,
          question: 'Please explain the differences in training between the Training Center and other domestic aviation universities (such as the Vietnam Aviation Academy)?',
          answer: 'answer for the id 5 question',
          toggle: false
        },
        {
          id: 6,
          question: 'What professions does the Flight Training Center train for?',
          answer: 'answer for the id 6 question',
          toggle: false
        }
      ],
      // Customer
      customerData: [
        {
          id: 1,
          img: 'com.jpg'
        },
        {
          id: 2,
          img: 'ao-airlines-logo.jpg'
        },
        {
          id: 3,
          img: 'Cambodia_Bayon_Airlines_Logo,_Aug_2015.png'
        },
        {
          id: 4,
          img: 'Hk.jpg'
        },
        {
          id: 5,
          img: 'Jetstar Air.png'
        },
        {
          id: 6,
          img: 'Untitled-1_03.png'
        },
        {
          id: 7,
          img: 'sky2.jpg'
        },
        {
          id: 8,
          img: 'Vasco2.jpg'
        },
        {
          id: 9,
          img: 'vnh.png'
        },
        {
          id: 10,
          img: 'Viets.jpg'
        }
      ],
      // Contact
      vnContact: [
        {
          branch: 'Chi nhánh Tổng công ty Hàng không Việt Nam - CTCP - Trung tâm huấn luyện bay',
          address: '117 Hồng Hà, Phường 2, Q. Tân Bình, TP. Hồ Chí Minh, Việt Nam',
          phoneNum: '(84-8) 38485 922',
          fax: '(84-8) 38485 830',
          website: 'vnaflighttraining.com.vn'
        }
      ],
      enContact: [
        {
          branch: 'Branch of Vietnam Airlines Corporation - JSC - Flight Training Center',
          address: '117 Hong Ha, Ward 2, Tan Binh District, Ho Chi Minh City, Vietnam',
          phoneNum: '(84-8) 38485 922',
          fax: '(84-8) 38485 830',
          website: 'vnaflighttraining.com.vn'
        }
      ],
      vnContactHeader: ['Địa chỉ', 'Điện thoại'],
      enContactHeader: ['Address', 'Phone Number']
    }
  },
  getters: {
    finalHistory (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnHistory
      } else {
        return state.enHistory
      }
    },
    finalQuality (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnQuality
      } else {
        return state.enQuality
      }
    },
    finalLocation (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnLocation
      } else {
        return state.enLocation
      }
    },
    finalQandA (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnQaData
      } else {
        return state.enQaData
      }
    },
    finalCustomer (state) {
      return state.customerData
    },
    finalContact (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnContact
      } else {
        return state.enContact
      }
    },
    finalContactHeader1 (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnContactHeader[0]
      } else {
        return state.enContactHeader[0]
      }
    },
    finalContactHeader2 (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnContactHeader[1]
      } else {
        return state.enContactHeader[1]
      }
    }
  },
  mutations: {
    vnShowAnswer (state, payload) {
      state.vnQaData[payload.value].toggle = !state.vnQaData[payload.value].toggle
    },
    enShowAnswer (state, payload) {
      state.enQaData[payload.value].toggle = !state.enQaData[payload.value].toggle
    }
  },
  actions: {
    finalShowAnswer (context, payload) {
      if (context.rootState.lang === 'vn') {
        context.commit('vnShowAnswer', payload)
      } else {
        context.commit('enShowAnswer', payload)
      }
    }
  }
}
